<template>
    <a class="slide-mon" :data-url="landUrl">
        <img v-if="cover" :src="cover" class="sprite-icons-video fl" alt="">
        <span v-if="title">{{title}}</span>
    </a>
</template>
<script>
export default{
    name: 'bannerAd',
    props: {
        config: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data(){
        // 通过调用方传入
        return {
            creatives: [], // 素材数组
            tag: {}, // 标签信息
            tagForbid: true, // 是否禁用标签 
        }
    },
    computed:{
        title(){
            return this?.creatives?.[0]?.title
        },
        cover(){
            return this?.creatives?.[0]?.images?.[0]?.url
        },
        landUrl(){
            return this?.creatives?.[0]?.link
        },
    }
}
</script>
<style lang="less" scoped>
.slide-mon {
    position: relative;
    height: 100%;
    display: flex !important;
    align-items: center;
    justify-content: flex-end;
    .sprite-icons-video {
        display: block;
        background: unset;
        background-size: contain;
        max-width: 250px; /*px*/
        height: 30px; /*px*/
        width: auto !important;
    }
    span {
        font-size: 28px;/*px*/
        line-height: 40px;
        color: #111111;
        max-width: 195px;/*px*/
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 6px;
    }
}
</style>